import { Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import PageLayout from '../subcomponents/PageLayout';
import ClassTab from './class/ClassTab';
import LinkProgramTab from './links-program/LinkProgramTab';
import SchoolclassGroupTab from './schoolclassGroup/SchoolclassGroupTab';
import LinkTimetableTab from './links-timetable/TimetableLinksTab';

export default function OrganisationManagementPage() {
    const [value, setValue] = useState(0);

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <PageLayout
            title={resourceFinal[appLanguage].words.MANAGEMENT_ORGANISATION}
            content={
                <>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange}>
                            <Tab label={resourceFinal[appLanguage].words.CLASSES} />
                            <Tab label={resourceFinal[appLanguage].words.SCHOOLCLASSGROUPS} />
                            <Tab label={`${resourceFinal[appLanguage].words.PROGRAM} ${resourceFinal[appLanguage].words.LINKS}`} />
                            <Tab label={`${resourceFinal[appLanguage].words.TIMETABLE} ${resourceFinal[appLanguage].words.LINKS}`} />
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0}>
                        <ClassTab />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <SchoolclassGroupTab />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <LinkProgramTab />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <LinkTimetableTab />
                    </TabPanel>
                </>
            }
            bottomBar
            fullScreen
        />
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            sx={{ display: value !== index ? 'none' : 'flex', flex: '1 1 auto' }}
        >
            {value === index && (
                <Box sx={{ display: 'flex', flex: '1 1 auto', p: 1 }}>
                    {children}
                </Box>
            )}
        </Box>
    );
};
